import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../../../contexts/LanguageContext';
import Navbar from '../../Layout/Navbar';
import Footer from '../../Layout/Footer';
import './ServiceDetail.css';
import Officeimg from './office.png';


const CommercialCleaning = () => {
  const { t } = useLanguage();

  return (
    <div className="service-detail-page">
      <Navbar />

      <section className="service-hero">
        <div className="container">
          <h1>{t('services.commercialCleaning.title', 'Commercial Cleaning Services')}</h1>
          <p>{t('services.commercialCleaning.subtitle', 'Professional office and business cleaning solutions')}</p>
        </div>
      </section>

      <section className="service-content-section">
        <div className="container">
          <div className="service-detail-content">
            <div className="service-detail-image">
               
              <img src={Officeimg} alt="Commercial Cleaning" />
            </div>

            <div className="service-detail-text">
              <h2>{t('services.commercialCleaning.heading', 'Comprehensive Business Cleaning Solutions')}</h2>
              <p>
                {t('services.commercialCleaning.description', 'Maintain a professional and welcoming workspace with our comprehensive commercial cleaning services. We understand that a clean office environment is essential for productivity, employee satisfaction, and making a positive impression on clients and visitors.')}
              </p>

            

              <h3>{t('services.commercialCleaning.whatWeInclude', 'What We Include')}</h3>
              <ul className="service-features">
                <li>{t('services.commercialCleaning.features.daily', 'Daily office cleaning and maintenance')}</li>
                <li>{t('services.commercialCleaning.features.restroom', 'Restroom sanitization and restocking')}</li>
                <li>{t('services.commercialCleaning.features.floors', 'Floor care including vacuuming, mopping, and buffing')}</li>
                <li>{t('services.commercialCleaning.features.windows', 'Window and glass cleaning')}</li>
                <li>{t('services.commercialCleaning.features.desks', 'Desk and workstation sanitization')}</li>
                <li>{t('services.commercialCleaning.features.trash', 'Trash and recycling removal')}</li>
                <li>{t('services.commercialCleaning.features.kitchen', 'Kitchen and break room cleaning')}</li>
        
              </ul>


              <h3>{t('services.commercialCleaning.serviceOptions', 'Service Options')}</h3>
              <div className="service-options">
                <div className="service-option-card">
                  <h4>{t('services.commercialCleaning.dailyCleaning.title', 'Daily Cleaning')}</h4>
                  <p>{t('services.commercialCleaning.dailyCleaning.description', 'Regular maintenance cleaning during or after business hours to keep your workspace consistently clean.')}</p>
                </div>
                <div className="service-option-card">
                  <h4>{t('services.commercialCleaning.weeklyDeep.title', 'Weekly Deep Cleaning')}</h4>
                  <p>{t('services.commercialCleaning.weeklyDeep.description', 'Comprehensive weekly cleaning that includes detailed attention to all areas and surfaces.')}</p>
                </div>
                <div className="service-option-card">
                  <h4>{t('services.commercialCleaning.specialized.title', 'Specialized Services')}</h4>
                  <p>{t('services.commercialCleaning.specialized.description', 'Custom cleaning solutions for specific industries including medical, retail, and hospitality.')}</p>
                </div>
              </div>

              <h3>{t('services.commercialCleaning.whyChoose', 'Why Choose Our Commercial Cleaning Service?')}</h3>
              <p>
                {t('services.commercialCleaning.whyChooseText', 'We work around your business hours to minimize disruption to your operations. Our team is trained in commercial cleaning standards and uses professional-grade equipment and eco-friendly products. We\'re fully licensed, insured, and bonded, and all our staff undergo thorough background checks. We can customize our services to meet your specific industry requirements and work with you to create a cleaning schedule that fits your business needs.')}
              </p>

              <div className="service-cta">
                <Link to="/contact" className="btn btn-primary">{t('services.getQuote', 'Get a Quote')}</Link>
                <Link to="/" className="btn btn-secondary">{t('services.backToServices', 'Back to Services')}</Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default CommercialCleaning;
